export const accentDark = {
    color: '#E24C1A',
    bgColor: '#fff',
    bgColorHover: '#823827',
    overlayColor: '#333333a8',
}
